export default __webpack_public_path__ + "static/media/Mark-6-Suit-07.ab74b517.jpg";